import PolicyPage from "../../components/PolicyPage";
import { PRIVACY_POLICY_URL } from "../../constants";

const Privacy = () => (
  <PolicyPage title="Privacy Policy" policyUrl={PRIVACY_POLICY_URL} />
);

export default Privacy;
